module.exports = __webpack_public_path__ + "static/media/magic-mouse.3cf7a781.png";